import React from "react";
import { Card, Typography } from "antd";
import { AreaChart, Area, XAxis, YAxis, Tooltip, ResponsiveContainer, Legend } from "recharts";

const { Title, Text } = Typography;

// Mock Compensation Data
const data = [
    { month: "Apr 23", fixPay: 400000, bonus: 300000, others: 300000 },
    { month: "May 23", fixPay: 500000, bonus: 250000, others: 250000 },
    { month: "Jun 23", fixPay: 550000, bonus: 200000, others: 250000 },
    { month: "Jul 23", fixPay: 600000, bonus: 300000, others: 100000 },
    { month: "Aug 23", fixPay: 650000, bonus: 250000, others: 100000 },
    { month: "Sep 23", fixPay: 700000, bonus: 200000, others: 100000 },
    { month: "Oct 23", fixPay: 750000, bonus: 150000, others: 100000 },
    { month: "Nov 23", fixPay: 800000, bonus: 100000, others: 100000 },
    { month: "Dec 23", fixPay: 850000, bonus: 50000, others: 100000 },
];

const CompensationChart: React.FC = () => {
    return (
        <>
            <ResponsiveContainer width="100%" height={400}>
                <AreaChart
                    data={data}
                    margin={{ top: 20, right: 30, left: 0, bottom: 0 }}
                >
                    <XAxis dataKey="month" tick={{ fill: "#888" }} />
                    <YAxis tickFormatter={(value) => `₹${(value / 1000).toFixed(1)}K`} />
                    <Tooltip
                        formatter={(value: number, name: string) => [`₹${value.toLocaleString()}`, name]}
                        contentStyle={{ backgroundColor: "#fff", border: "1px solid #ddd" }}
                    />
                    <Legend />
                    <Area
                        type="monotone"
                        dataKey="fixPay"
                        name="FIX PAY"
                        stroke="#52c41a"
                        fill="#b3ffb3"
                    />
                    <Area
                        type="monotone"
                        dataKey="bonus"
                        name="BONUS"
                        stroke="#faad14"
                        fill="#ffdf99"
                    />
                    <Area
                        type="monotone"
                        dataKey="others"
                        name="OTHERS"
                        stroke="#722ed1"
                        fill="#d3b3ff"
                    />
                </AreaChart>
            </ResponsiveContainer >
        </>
    );
};

export default CompensationChart;
